/* Copyright (c) 2018 Scaper */

import { TypedAction, TypedReducer, setWith } from "redoodle";
import { IPlace } from "../../functions/src/api/placeInterface";
import { IPlaceState } from "./placeState";

export const DELETE_PLACE = TypedAction.define("place::DELETE_PLACE")<{
    placeId: string;
}>();
export const SET_PLACE = TypedAction.define("place::SET_PLACE")<{
    place: IPlace;
}>();
export const SET_PLACE_LOADING = TypedAction.define("place::SET_PLACE_LOADING")<{
    placeId: string;
}>();

export const placeReducer = TypedReducer.builder<IPlaceState>()
    .withHandler(DELETE_PLACE.TYPE, (state, { placeId }) => {
        return setWith(state, {
            places: setWith(state.places, { [placeId]: undefined })
        });
    })
    .withHandler(SET_PLACE.TYPE, (state, { place }) => {
        const { place_id } = place;
        return setWith(state, {
            places: setWith(state.places, { [place_id]: place })
        });
    })
    .withHandler(SET_PLACE_LOADING.TYPE, (state, { placeId }) => {
        return setWith(state, {
            places: setWith(state.places, { [placeId]: "LOADING" })
        });
    })
    .build();
